import React, { useState, useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { BONUSES } from '../lib/content';
import { goToPurchase } from '../lib/checkout';
export function BonusCarousel() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  function scrollToBonus(index: number) {
    const track = trackRef.current;
    const card = track?.children[index] as HTMLElement | undefined;
    card?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
    setActiveIndex(index);
  }
  function handleScroll() {
    const track = trackRef.current;
    if (!track) return;
    const nextIndex = Math.round(track.scrollLeft / track.clientWidth);
    setActiveIndex(Math.min(Math.max(nextIndex, 0), BONUSES.length - 1));
  }
  return <div className="relative -mx-4" data-id="element-70">
      <div ref={trackRef} onScroll={handleScroll} role="region" aria-label="Bonus previews" className="flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-71">
        {BONUSES.map((bonus, index) => <article key={bonus.title} className="w-[86%] shrink-0 snap-center overflow-hidden rounded-2xl border border-orange-500/35 bg-neutral-900 shadow-xl" data-id="element-72">
            <button type="button" onClick={goToPurchase} className="group block w-full overflow-hidden text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400 focus-visible:ring-offset-2 focus-visible:ring-offset-black" aria-label={`Go to purchase ${bonus.title}`} data-id="element-73">
              <img src={bonus.preview} alt={`${bonus.title} preview`} className="aspect-square w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" data-id="element-74" />
            </button>
            <div className="p-4" data-id="element-75">
              <p className="text-xs font-extrabold uppercase tracking-[0.16em] text-orange-400" data-id="element-76">
                Included free today
              </p>
              <h3 className="mt-1 text-base font-extrabold leading-snug text-white" data-id="element-77">
                <span className="mr-1.5" aria-hidden data-id="element-78">
                  {bonus.emoji}
                </span>
                {bonus.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-neutral-300" data-id="element-79">
                {bonus.body}
              </p>
            </div>
          </article>)}
      </div>

      <div className="mt-1 flex items-center justify-center gap-3" data-id="element-80">
        <button type="button" onClick={() => scrollToBonus(Math.max(activeIndex - 1, 0))} disabled={activeIndex === 0} aria-label="Previous bonus" className="flex h-9 w-9 items-center justify-center rounded-full border border-orange-500/40 bg-neutral-900 text-orange-400 transition-colors hover:bg-orange-500 hover:text-black disabled:cursor-not-allowed disabled:opacity-35" data-id="element-81">
          <ChevronLeftIcon className="h-4 w-4" data-id="element-82" />
        </button>

        <div className="flex items-center gap-1.5" aria-label={`${activeIndex + 1} of ${BONUSES.length} bonuses`} data-id="element-83">
          {BONUSES.map((bonus, index) => <button key={bonus.title} type="button" onClick={() => scrollToBonus(index)} aria-label={`Show ${bonus.title}`} aria-current={index === activeIndex ? 'true' : undefined} className={`h-2 rounded-full transition-all ${index === activeIndex ? 'w-5 bg-orange-400' : 'w-2 bg-neutral-600 hover:bg-neutral-400'}`} data-id="element-84" />)}
        </div>

        <button type="button" onClick={() => scrollToBonus(Math.min(activeIndex + 1, BONUSES.length - 1))} disabled={activeIndex === BONUSES.length - 1} aria-label="Next bonus" className="flex h-9 w-9 items-center justify-center rounded-full border border-orange-500/40 bg-neutral-900 text-orange-400 transition-colors hover:bg-orange-500 hover:text-black disabled:cursor-not-allowed disabled:opacity-35" data-id="element-85">
          <ChevronRightIcon className="h-4 w-4" data-id="element-86" />
        </button>
      </div>
      <p className="mt-3 text-center text-xs text-neutral-400" data-id="element-87">
        Swipe to preview all 5 bonuses
      </p>
    </div>;
}